import React from "react";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Header } from "../../components";
import { RoundedButton } from "../../../../../elements";
import {
  EmptyMessagesSuppressionContainer,
  ButtonContainer,
  ContentContainer,
} from "./EmptyMessagesSuppression.styled";

const EmptyMessagesSuppression = () => {
  const navigate = useNavigate();

  const handleCreate = () => {
    navigate("/v2/suppression-rules/create");
  };

  return (
    <ContentContainer>
      <Header
        title="Supression rules"
        description="Prevent over-communication by setting limits on when contacts are reached."
        textAlign="left"
      />
      <EmptyMessagesSuppressionContainer>
        <Header
          title="Create suppression rules"
          description="Manage rules that control with contacts in conversations."
          textAlign="center"
          headerSize="22px"
        />
        <ButtonContainer>
          <RoundedButton
            kind="blue"
            onClick={handleCreate}
            height="40px"
            width="140px"
          >
            <AddIcon />
            Create
          </RoundedButton>
        </ButtonContainer>
      </EmptyMessagesSuppressionContainer>
    </ContentContainer>
  );
};

export default EmptyMessagesSuppression;
